import React from 'react';
import {colors} from "../styles/colors";
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack, resetNavigationToOverview} from "../navigation/NavigationActions";
import {connect} from "react-redux";
import {
    FacebookShareButton,
    WhatsappShareButton,
    EmailShareButton, FacebookIcon, WhatsappIcon, EmailIcon,
} from 'react-share';
import {saveHideShare, getHideShare} from "../utils/settingsStore";
import {ListItem} from "material-ui";
import {Done, InfoOutline, UnfoldMore} from "material-ui-icons";
import {getUserSync} from "../utils/auth";
import Rater from 'react-rater'
import 'react-rater/lib/react-rater.css'
import MyButton from "../components/MyButton";
import Header from "../components/Header";
import i18n from 'i18next';
import ReactDOM from "react-dom";
import {DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";
import './ReorderScreen.css';
import moment from "moment";
import {
    CONFIRMED,
    CURRENT_CONFIRMED,
    CURRENT_PAUSE,
    CURRENT_PENDING,
    MISSED,
    PAUSE,
    PAUSE_CONFIRMED,
    PENDING,
    TOMORROW,
    CHEATED,
    TOMORROW_PAUSE,
    SUSPICIOUS,
} from '../overview/DayStates';
import DndDayListItem from "../overview/DnDDayListItem";
import IconButton from "material-ui/IconButton/index";
import AccountBalanceWallet from "material-ui-icons/AccountBalanceWallet";
import {submitFetchData} from "../workout/SubmitAction";
import {loadingReorderFailed, reorderCorrupted, reorderFetchData, reorderLoading} from "./ReorderAction";
import InfoSnack from "../utils/InfoSnack";


// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};


const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",

    // change background colour if dragging
    background: isDragging ? "lightgreen" : "transparent",

    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    width: '100%'
});



class ReorderScreen extends React.PureComponent {

    constructor(props) {
        super(props);
        const draggableItems = this.props.days.filter(obj =>
            (obj.state === PAUSE ||
                obj.state === CURRENT_PAUSE ||
                obj.state === CURRENT_PENDING ||
                obj.state === PENDING ||
                obj.state === TOMORROW ||
                obj.state === TOMORROW_PAUSE))

        draggableItems.pop();
        let initialPosition = 30 - draggableItems.length
        for (let i = 0; i < draggableItems.length; i++) {
            draggableItems[i].index = initialPosition
            initialPosition++;
        }

        this.state = {
            items: draggableItems
        };
        this.onDragEnd = this.onDragEnd.bind(this);
    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            this.state.items,
            result.source.index,
            result.destination.index
        );

        let initialPosition = this.state.items[0].index
        const startDeadline = this.state.items[0].start_deadline;
        for (let i = 0; i < items.length; i++) {
            items[i].index = initialPosition
            items[i].start_deadline = moment(startDeadline).add(i, 'days');
            initialPosition++;
        }

        this.setState({
            items
        }, () => {
            console.log(this.state.items)
        });


    }

    isToday(start_deadline) {
        const start = moment(start_deadline);
        return moment(start).isSame(moment(), 'day');
    }

    componentDidUpdate(prevProps) {
        this.initNetworkError(prevProps);
    }

    initNetworkError(prevProps) {
        if (prevProps.loadingReorderFailed !== this.props.loadingReorderFailed && prevProps.reorderLoading) {
            if (this.infoSnack) {
                this.infoSnack.showSnack(this.props.t('common:cell_failed'));
            }
        }else if (prevProps.reorderCorrupted !== this.props.reorderCorrupted && prevProps.reorderLoading) {
            if (this.infoSnack) {
                this.infoSnack.showSnack(this.props.t('common:moveDaysCorrupted'));
            }
        }
    }

    submitReorderData = () => {
        this.props.reorderFetchData(this.state.items);
    };

    render() {
        const {t} = this.props;
        return (
            <div className='reorderScreenWrapper noSelectAtAll'>
                <InfoSnack onRef={(ref) => (this.infoSnack = ref)} />
                <div className='reorderWrapper'>
                    <div className="overviewHeader">
                        <IconButton
                            onClick={() => this.props.goBackToOverview()}
                            color="inherit">
                            <ArrowBack />
                        </IconButton>

                        <h1 style={styles.flex}>{t('common:moveDays')}</h1>

                        <IconButton
                            onClick={() => {this.submitReorderData();}}
                            color="inherit">
                            <Done />
                        </IconButton>

                    </div>


                    <div className='dndListWrapper'>
                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable pure={false} areStatePropsEqual={false} droppableId="droppable">
                                {(provided, snapshot) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        {this.state.items.map((item, index) => (
                                            <Draggable
                                                isDragDisabled={item.state !== PAUSE && item.state !== CURRENT_PAUSE && item.state !== TOMORROW_PAUSE}
                                                key={item._id} draggableId={item._id} index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}
                                                    >
                                                        <DndDayListItem
                                                            id={item._id}
                                                            key={item._id}
                                                            day={item}
                                                            isToday={this.isToday(
                                                                item.start_deadline
                                                            )}
                                                            loading={false}
                                                        />

                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
            </div>
        );
    }
}


const styles = ({
    shareContainer: {
        maxWidth: 512,
        margin: '0 auto',
        paddingTop: 72,
        paddingRight: 16,
        paddingLeft: 16,
    },
    flex: {
        flex: 1,
        color: colors.white
    },
    share: {
        marginTop: 16,
        marginBottom: 16,
    },
    highlight: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 16,
        backgroundColor: colors.white,
        boxShadow: `0 1px 3px 0 rgba(41,70,97,.2)`,
        borderRadius: 3,
    },
    icon: {
        marginRight: 16,
    },
    smLayout: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        outline: 'none'
    },
    smText: {
        paddingLeft: 16
    },
    smListButton: {
        paddingLeft: 16
    },
    smSkip: {
        paddingTop: 16,
        paddingBottom: 16,
        textDecoration: 'underline',
        cursor: 'pointer',
        textAlign: 'center',
        color: colors.text_light
    },
    hideShareLayout: {
        paddingTop: 32,
    },
    thanks: {
        paddingBottom: 16
    }
});

const mapStateToProps = (state) => {
    return {
        days: state.days,
        loadingReorderFailed: state.loadingReorderFailed,
        reorderLoading: state.reorderLoading,
        submitLoading: state.submitLoading,
        reorderCorrupted: state.reorderCorrupted
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reorderFetchData: (days) => dispatch(reorderFetchData(days)),
        goBackToOverview: () => dispatch(resetNavigationToOverview()),
        goBack: () => dispatch(navigationBack())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate(['rating', 'friends', 'common'])(ReorderScreen));


// WEBPACK FOOTER //
// ./src/reorder/ReorderScreen.js